module.exports = __webpack_public_path__ + "assets/game-type-read-aloud.49dcd225.svg";